module.exports = "span{\n    color:red;\n    font-size: 12px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/edit-profile/edit-profile.component.css
// module id = ./src/app/myprofile/edit-profile/edit-profile.component.css
// module chunks = main